import { FC } from 'react';
import Spinner from '~public/img/icons/spinner.svg';

export interface LoadingProps {
    testId?: string;
    loadingText?: string;
}

const Loading: FC<LoadingProps> = (props: LoadingProps) => {
    const { testId, loadingText } = props;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-5" data-test-id={testId}>
            <div className="flex flex-col items-center gap-10 text-center">
                {loadingText && <div className="text-[2em] text-white">{loadingText}</div>}
                <div data-test-id={`${testId}-spinner`}>
                    <Spinner className="animate-loading-spin" />
                </div>
            </div>
        </div>
    );
};

export default Loading;
